"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CtaButtonGroupProps_1 = require("./CtaButtonGroupProps");
var CtaButtonGroupState_1 = require("./CtaButtonGroupState");
/** Platform UI Components */
var Button_1 = require("@idp/duc/components/atoms/Button");
var Link_1 = require("@idp/duc/components/atoms/Link");
/** Stylesheets */
var styles = require("./CtaButtonGroup.scss");
var CtaButtonGroup = /** @class */ (function (_super) {
    __extends(CtaButtonGroup, _super);
    function CtaButtonGroup(props) {
        var _this = _super.call(this, props) || this;
        _this.state = new CtaButtonGroupState_1.default();
        _this.onPrimaryBtnClick = _this.onPrimaryBtnClick.bind(_this);
        _this.onSecondaryBtnClick = _this.onSecondaryBtnClick.bind(_this);
        _this.onSecondaryBtnLinkClick = _this.onSecondaryBtnLinkClick.bind(_this);
        return _this;
    }
    CtaButtonGroup.prototype.onPrimaryBtnClick = function () {
        this.props.primaryBtnEvents.onClick();
    };
    CtaButtonGroup.prototype.onSecondaryBtnClick = function () {
        this.props.secondaryBtnEvents.onClick();
    };
    CtaButtonGroup.prototype.onSecondaryBtnLinkClick = function () {
        this.props.secondaryBtnLinkEvents.onClick();
    };
    CtaButtonGroup.prototype.render = function () {
        var buttonType;
        if (!this.props.options) {
            buttonType = '';
        }
        else if (this.props.options.type === CtaButtonGroupProps_1.CtaButtonGroupType.BUTTON_REVERSE_RIGHT) {
            buttonType = styles.buttonReverseRight;
        }
        else if (this.props.options.type === CtaButtonGroupProps_1.CtaButtonGroupType.BUTTON_REVERSE_LEFT) {
            buttonType = styles.buttonReverseLeft;
        }
        return (React.createElement("div", { className: [styles.loginCtaButtonsGroupWrapper].join(' ') },
            React.createElement("div", { className: [styles.flexButton, buttonType].join(' ') },
                ((this.props.data.primaryBtnText) &&
                    (this.props.options && !this.props.options.hidePrimaryBtn)) &&
                    React.createElement(Button_1.default, { kind: "primaryBlue", disabled: this.props.data.disabledPrimaryBtn, onClick: this.onPrimaryBtnClick, spinner: this.props.data.showSpinner, testId: this.props.data.primaryBtnTestId ? this.props.data.primaryBtnTestId : '' }, this.props.data.primaryBtnText),
                ((this.props.data.secondaryBtnText) &&
                    (this.props.options && !this.props.options.hideSecondaryBtn)) &&
                    React.createElement(Button_1.default, { kind: "secondary", onClick: this.onSecondaryBtnClick, testId: this.props.data.secondaryBtnTestId ? this.props.data.secondaryBtnTestId : '' }, this.props.data.secondaryBtnText),
                ((this.props.data.secondaryBtnLinkText) &&
                    (this.props.options && !this.props.options.hideSecondaryBtnLink)) &&
                    React.createElement(Link_1.default, { kind: "textPlain", onClick: this.onSecondaryBtnLinkClick, testId: this.props.data.secondaryBtnTestId ? this.props.data.secondaryBtnTestId : '' }, this.props.data.secondaryBtnLinkText))));
    };
    return CtaButtonGroup;
}(React.Component));
exports.default = CtaButtonGroup;
//# sourceMappingURL=CtaButtonGroup.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/common/CtaButtonGroup/CtaButtonGroup.js
// module id = 1522
// module chunks = 8